import Footer from "src/components/common/frame/footer";
import { useAuthStore, User } from "src/components/main/authStore";
import { myAxios, boolAndReducer } from "src/components/common/functions";
import { useLoaderData, useRevalidator, useRouteLoaderData } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Training } from "./types";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
export default function TrainingList(){
    //---------------------------------------------------------------------
    const revalidator = useRevalidator();
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const user = useAuthStore(state => state.user) as User;
    const canManageTraining = user.trainings === "edit";
    //---------------------------------------------------------------------
    const rawData = useRouteLoaderData("trainings");
    const trainings = useLoaderData() as Training[];
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //---------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredTrainings = trainings.filter(training => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(training)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentPageItems = filteredTrainings.slice(indexOfFirstItem, indexOfLastItem);
    //---------------------------------------------------------------------
    return (
        <div className = "cssContent pb8rem">
            <nav className = "d-flex align-items-center flex-wrap gap-3 mt-2 mb-4">
                <span className = "me-3 mb-0">
                    <label
                        children = "Search:"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                </span>
                {canManageTraining && <Link children = "Add" to = "Add" className = "btn btn-primary ms-auto trainingActionButton"/>}
            </nav>
            {!filteredTrainings.length?<div className = "cssLoading">Empty</div>:
            <>
            <div className = "table-responsive d-none d-md-block">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Training Name</th>
                            <th>Status</th>
                            <th>Score</th>
                            {canManageTraining?<>
                            <th></th>
                            <th></th>
                            </>:null}
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageItems.map((training, trainingIndex) => 
                        <tr key = {trainingIndex}>
                            <td>
                                {training.description === "completed"?
                                <Link
                                    children = {training.name}
                                    className = {training.description === "completed"?"text-primary pointer":""}
                                    to = {`${training.id}/Run`}
                                    replace
                                />
                                :<span children = {training.name}/>}
                            </td>
                            <td className = {rawData[training.id]?.status === "Passed"?"text-success":rawData[training.id]?.status === "Failed"?"text-danger":""}>{rawData[training.id]?.status}</td>
                            <td>{rawData[training.id]?.status === "Passed" || rawData[training.id]?.status === "Failed"?rawData[training.id].curScore + " / " + rawData[training.id].totalScore:null}</td>
                            {canManageTraining?
                            <>
                            <td>
                                <Link
                                    children = "Edit"
                                    className = "btn btn-primary"
                                    to = {`${training.id}/Edit`}
                                ></Link>
                            </td>
                            <td>
                                <button
                                    id = {training.id + " Delete"}
                                    className = "btn btn-danger"
                                    onClick = {async() => {
                                        if(!window.confirm("Are you sure to delete this training?")) return;
                                        const formData = new FormData();
                                        formData.append("fileId", training.id);
                                        //-------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios({ fileName: "trainings/deleteTraining.php", formData: formData });
                                        setShowLoader(false);
                                        if(!res) return;
                                        revalidator.revalidate();
                                    }}
                                >Delete</button>
                            </td>
                            </>:null}
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <div className = "d-md-none">
                {currentPageItems.map((training, trainingIndex) => {
                    const status = rawData[training.id]?.status;
                    const score = status === "Passed" || status === "Failed" ? `${rawData[training.id].curScore} / ${rawData[training.id].totalScore}` : "";
                    return (
                        <div key = {trainingIndex} className = "border rounded p-3 mb-3">
                            <div className = "fw-bold mb-2">
                                {training.description === "completed" ?
                                <Link
                                    children = {training.name}
                                    className = "text-primary"
                                    to = {`${training.id}/Run`}
                                    replace
                                />
                                : training.name}
                            </div>
                            <div className = {`mb-1 ${status === "Passed" ? "text-success" : status === "Failed" ? "text-danger" : ""}`}>Status: {status || "-"}</div>
                            <div className = "mb-3">Score: {score || "-"}</div>
                            {canManageTraining ?
                            <div className = "d-flex flex-column gap-2">
                                <Link
                                    children = "Edit"
                                    className = "btn btn-primary trainingActionButton"
                                    to = {`${training.id}/Edit`}
                                />
                                <button
                                    type = "button"
                                    className = "btn btn-danger trainingActionButton"
                                    onClick = {async() => {
                                        if(!window.confirm("Are you sure to delete this training?")) return;
                                        const formData = new FormData();
                                        formData.append("fileId", training.id);
                                        setShowLoader(true);
                                        const res = await myAxios({ fileName: "trainings/deleteTraining.php", formData: formData });
                                        setShowLoader(false);
                                        if(!res) return;
                                        revalidator.revalidate();
                                    }}
                                >Delete</button>
                            </div>
                            : null}
                        </div>
                    );
                })}
            </div>
            <Footer
                length = {filteredTrainings.length}

                currentPage = {currentPage}
                setCurrentPage = {setCurrentPage}
                itemsPerPage = {itemsPerPage}
                setItemsPerPage = {setItemsPerPage}
            />
            </>}
        </div>
    )
}
